import { z } from 'zod'
import type { CustomerERPSettings } from '../../models/CustomerERPSettings'
import { RequiredFieldsToRegisterERPSettingsDTO, mapDTOToRequiredFieldsToRegisterERPSettings, mapRequiredFieldsToRegisterERPSettingsToDTO } from './RequiredFieldsToRegisterERPSettingsDTO'
import { BaseCompanyDTO, mapDTOToBaseCompany } from '~/domain/shared/company/gateways/DTOs/BaseCompanyDTO'

export const CustomerERPSettingsDTO = z.object({
  required_fields_to_register: RequiredFieldsToRegisterERPSettingsDTO.nullish(),
  is_allowed_provide_new_customer_for_all_companies: z.boolean().nullish(),
  companies: z.array(BaseCompanyDTO).nullish(),
  company_ids: z.array(z.number()).nullish(),
  is_enabled_notify_sync_customer: z.boolean().nullish()
})

export type CustomerERPSettingsDTO = z.infer<typeof CustomerERPSettingsDTO>

export function mapCustomerERPSettingsToDTO (model: CustomerERPSettings): CustomerERPSettingsDTO {
  return {
    required_fields_to_register: model.requiredFieldsToRegister ? mapRequiredFieldsToRegisterERPSettingsToDTO(model.requiredFieldsToRegister) : undefined,
    is_allowed_provide_new_customer_for_all_companies: model.isAllowedProvideNewCustomerForAllCompanies,
    company_ids: !model.isAllowedProvideNewCustomerForAllCompanies ? model.companies.map(company => company.id).filter((id): id is number => id !== undefined) : undefined,
    is_enabled_notify_sync_customer: model.isEnabledNotifySyncCustomer
  }
}

export function mapDTOToCustomerERPSettings (dto: CustomerERPSettingsDTO): CustomerERPSettings {
  return {
    isAllowedProvideNewCustomerForAllCompanies: dto.is_allowed_provide_new_customer_for_all_companies ?? false,
    companies: dto.companies?.map(mapDTOToBaseCompany) ?? [],
    isEnabledNotifySyncCustomer: dto.is_enabled_notify_sync_customer ?? false,
    requiredFieldsToRegister: dto.required_fields_to_register ? mapDTOToRequiredFieldsToRegisterERPSettings(dto.required_fields_to_register) : undefined
  }
}
